import { useCallback, useState } from "react";
import { SERVER_URL } from "../../../constants.js";

function getToken() {
  return sessionStorage.getItem("bearer");
}

async function fetchOk(url, options) {
  const res = await fetch(url, options);
  const text = await res.text().catch(() => "");
  return { ok: res.ok, status: res.status, text };
}

async function runInBatches(tasks, batchSize = 3) {
  const results = [];
  for (let i = 0; i < tasks.length; i += batchSize) {
    const batch = tasks.slice(i, i + batchSize);
    const batchResults = await Promise.all(batch.map((fn) => fn()));
    results.push(...batchResults);
  }
  return results;
}

export default function useTransferMutations() {
  const [loading, setLoading] = useState(false);

  const addTransfers = useCallback(async ({ transfer, targets }) => {
    const token = getToken();
    setLoading(true);
    try {
      const results = await runInBatches(
        (targets || []).map((t) => () => {
          const isAdult =
            String(t?.personType || "").toUpperCase() === "ADULT" ||
            (t?.adultId && Number(t.adultId) !== 0);

          const url = isAdult
            ? `${SERVER_URL}api/adult-transfers/${t.adultId}`
            : `${SERVER_URL}api/transfers/${t.studentId}`;

          return fetchOk(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(transfer),
          });
        })
      );
      return { ok: results.every((r) => r.ok), results };
    } finally {
      setLoading(false);
    }
  }, []);


  const editTransfers = useCallback(async ({ transfer, targets }) => {
    // targets: [{ studentId, transferId }]
    const token = getToken();
    setLoading(true);
    try {
      const results = await runInBatches(
        (targets || []).map(({ transferId }) => () =>
          fetchOk(`${SERVER_URL}api/transferid/${transferId}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(transfer),
          })
        )
      );
      return { ok: results.every((r) => r.ok), results };
    } finally {
      setLoading(false);
    }
  }, []);

  const deleteTransferById = useCallback(async (transferId) => {
    const token = getToken();
    setLoading(true);
    try {
      const { ok, status, text } = await fetchOk(`${SERVER_URL}api/transferid/${transferId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { ok, status, text };
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, addTransfers, editTransfers, deleteTransferById };
}

